import { Configuration } from './config.types';

import appConfig from './config.app.json';
import bilbaoConfig from './config.bilbao.json';
import {Camera, Rectangle} from "cesium";

const configuration: Configuration = bilbaoConfig as Configuration;

const getRectangle = () => {
    if(!configuration?.limits?.cartographicLimit) {
        return Rectangle.MAX_VALUE;
    }
    const {longitude, latitude} = configuration.initial;
    const delta = configuration.limits.cartographicLimit;

    return Rectangle.fromDegrees(
        (longitude-2*delta),
        (latitude-2*delta),
        (longitude+2*delta),
        (latitude+2*delta));
};

export const cartographicLimitRectangle = getRectangle();

Camera.DEFAULT_VIEW_RECTANGLE = cartographicLimitRectangle;
Camera.DEFAULT_VIEW_FACTOR = -0.01;

export default configuration;